import { useState, useEffect } from 'react';
export function useBrowser() {
    function agentHas(agent) {
        return navigator.userAgent.toLowerCase().search(agent) > -1;
    }
    function isFirefox() {
        return agentHas('firefox') && !agentHas('ios');
    }
    function isEdge() {
        return agentHas('edg') && !agentHas('ios');
    }
    function isOpera() {
        return agentHas('opr') && !agentHas('ios');
    }
    function isChrome() {
        return agentHas('chrome') && !agentHas('ios');
    }
    function isSafari() {
        return agentHas('safari') && !agentHas('ios');
    }
    function isIOS() {
        return /iPad|iPhone|iPod|iWatch/.test(navigator.userAgent);
    }
    function checkBrowser() {
        if (isFirefox()) {
            return 'Firefox';
        }
        if (isEdge()) {
            return 'Edge';
        }
        if (isOpera()) {
            return 'Opera';
        }
        if (isChrome()) {
            return 'Chrome';
        }
        if (isIOS()) {
            return 'IOS';
        }
        if (isSafari()) {
            return 'Safari';
        }
        return 'Unknown';
    }
    var _a = useState(checkBrowser()), browser = _a[0], setBrowser = _a[1];
    useEffect(function () {
        setBrowser(checkBrowser());
    }, [navigator, window, document]);
    // TODO: remove once Safari is sorted
    // console.log('browser', browser);
    return browser;
}
// ~~~~~ WINDOWS ~~~~~
// Firefox
// Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:109.0) Gecko/20100101
// Firefox/119.0
// Edge
// Mozilla/5.0 (Windows NT 10.0; Win64; x64)
// AppleWebKit/537.36 (KHTML, like Gecko)
// Chrome/119.0.0.0
// Safari/537.36
// Edg/119.0.0.0
// Opera
// Mozilla/5.0 (Windows NT 10.0; Win64; x64)
// AppleWebKit/537.36 (KHTML, like Gecko)
// Chrome/118.0.0.0
// Safari/537.36
// OPR/104.0.0.0
// Chrome
// Mozilla/5.0 (Windows NT 10.0; Win64; x64)
// AppleWebKit/537.36 (KHTML, like Gecko)
// Chrome/119.0.0.0
// Safari/537.36
// ~~~~~ ANDROID ~~~~~
// Chrome
// Mozilla/5.0 (Linux; Android 10; K)
// AppleWebKit/537.36 (KHTML, like Gecko)
// Chrome/119.0.0.0 Mobile
// Safari/537.36
// ~~~~~ MAC ~~~~~
// Safari
// Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)
// AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.1
// Safari/605.1.15
// Chrome
// Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)
// AppleWebKit/537.36 (KHTML, like Gecko)
// Chrome/119.0.0.0
// Safari/537.36
// ~~~~~ IPHONE ~~~~~
// Safari
// Mozilla/5.0 (iPhone; CPU iPhone OS 16_6_1 like Mac OS X)
// AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.6 Mobile/15E148
// Safari/604.1
// Chrome
// Mozilla/5.0 (iPhone; CPU iPhone OS 16_6 like Mac OS X)
// AppleWebKit/605.1.15 (KHTML, like Gecko)
// CriOS/119.0.6045.169 Mobile/15E148
// Safari/604.1
